// src/api/planApi.js
// Per-date daily plan — load and save blocks for a specific date.

import apiClient from "./apiClient";

// Load plan for a specific date (YYYY-MM-DD)
export async function loadPlan(date) {
  const response = await apiClient.get(`/api/plan/${date}`);
  return response.data;
}

// Save plan for a specific date
export async function savePlan(date, blocks) {
  const response = await apiClient.put(`/api/plan/${date}`, { blocks });
  return response.data;
}

// Load day canvas for a specific date — returns { blocks, savedDate, exists }
export async function loadDayCanvas(date) {
  try {
    const response = await apiClient.get(`/api/plan/canvas/${date}`);
    return response.data;
  } catch { return null; }
}

// Save day canvas for a specific date — blocks can be array or {blocks, savedDate} object
export async function saveDayCanvas(date, payload) {
  const blocks = Array.isArray(payload) ? payload : (payload?.blocks || payload);
  const response = await apiClient.put(`/api/plan/canvas/${date}`, { blocks });
  return response.data;
}
